<template>
  <div class="kaoshijieshu">
    <img src="@/assets/image/jieshu.png" />
    <h1>考试完成</h1>
    <!-- <div class="fenshu">{{ examResult.score }}分</div>
    <ul>
      <li>
        <p class="zhengquelv">{{ examResult.rightPercent }}</p>
        <span>正确率</span>
      </li>
      <li>
        <p class="zhengque">{{ examResult.rightNum }}<i>道</i></p>
        <span>正确题数</span>
      </li>
      <li>
        <p class="cuowu">
          {{ examResult.subjectNum - examResult.rightNum }}<i>道</i>
        </p>
        <span>错误题数</span>
      </li>
      <li>
        <p class="zongshu">{{ examResult.subjectNum }}<i>道</i></p>
        <span>总题数</span>
      </li>
    </ul> -->
    <!-- <a href="javascript:;" class="jiexi">查看解析</a>
    <a href="p_index.html">返回个人主页</a>  -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      recordId: "",
      timer: null,
      examResult: {},
    };
  },
  created() {
    if (this.$route.query.recordId) {
      this.recordId = this.$route.query.recordId;
      this.beginTimer();
    }
  },
  methods: {
    beginTimer() {
      let _this = this;
      _this.timer = setInterval(_this.getExamResult(), 1000);
    },
    getExamResult() {
      let _this = this;
      let parmas = {
        recordId: _this.recordId,
      };
      _this.$api.examination
        .getExamRecordResult(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            layer.closeAll();
            _this.examResult = res.data;
            clearInterval(timer);
          } else {
            layer.load(3, {
              shade: 0.1,
              // content: "正在查询考试结果...",
              // content: "正在提交考试...",
              success: function (layero) {
                layero.find(".layui-layer-content").css({
                  paddingTop: "40px",
                  width: "200px",
                  "font-size": "15px",
                  color: "white",
                  textAlign: "center",
                  backgroundPositionX: "center",
                });
              },
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/exam/examResult.vue